import type { Project } from '../types/project'
import { brands } from './brands'

export const projects: Project[] = [
  {
    id: 'certifieddevs',
    password: 'devs-2026',
    brand: brands.certifieddevs,
    name: 'CertifiedDevs',
    client: 'Developer talent network',
    summary:
      'Talent marketplace connecting certified developers with hiring companies. Sales focus is on employer subscriptions.',
    stage: 'Growth',
    owner: 'Jasper',
    updated: '2 hours ago',
    tools: [
      {
        id: 'cd-claude',
        name: 'Claude.ai',
        description: 'Drafting, research summaries and outreach copy.',
        url: 'https://claude.ai/login',
        category: 'Research',
        icon: 'sparkles',
        access: 'open',
      },
      {
        id: 'cd-attio',
        name: 'Attio CRM',
        description: 'Employer pipeline, contacts and deal stages.',
        url: 'https://app.attio.com/auth/sign-in',
        category: 'CRM',
        icon: 'database',
        access: 'personal',
        credentialHint: 'Sign in with your own email address',
      },
      {
        id: 'cd-apollo',
        name: 'Apollo.io',
        description: 'Prospecting, contact data and outreach sequences.',
        url: 'https://app.apollo.io/',
        category: 'Research',
        icon: 'search',
        access: 'open',
        screenshot: {
          label: 'Apollo.io login details',
          url: 'https://cdn.magicpatterns.com/uploads/76JMiT4ExF36jwVMAmWzjz/image.png',
          alt: 'Apollo.io sign-in form showing the shared email address and password',
          note: 'Internal only — do not share outside the team',
        },
      },
    ],
    documents: [
      {
        id: 'cd-doc-1',
        name: 'Sales folder',
        kind: 'folder',
        url: 'https://drive.google.com/drive/folders/175rl3Va1pqLSGCYRbCqrnXg-NjRYCDy4?usp=drive_link',
        owner: 'Google Drive',
        updated: 'Shared with team',
      },
      {
        id: 'cd-doc-2',
        name: 'Briefing and Login details',
        kind: 'doc',
        url: 'https://drive.google.com/file/d/1B1ePhZWfTLrwvy1w0a2EB7UxwIftg2KA/view?usp=sharing',
        owner: 'Google Drive',
        updated: 'Shared with team',
      },
      {
        id: 'cd-doc-3',
        name: 'Website — certifieddevs.com',
        kind: 'link',
        url: 'https://certifieddevs.com',
        owner: 'Live site',
        updated: 'Public',
      },
    ],
  },
  {
    id: 'laravel-certification',
    password: 'laravel-launch',
    brand: brands['laravel-certification'],
    name: 'Certification for Laravel',
    client: 'New certification launch',
    summary:
      'Bringing the official Laravel certification to market: exam build, launch partners and early-bird sales.',
    stage: 'Launch',
    owner: 'Jasper',
    updated: 'Yesterday',
    tools: [
      {
        id: 'laravel-claude',
        name: 'Claude.ai',
        description: 'Drafting, research summaries and outreach copy.',
        url: 'https://claude.ai/login',
        category: 'Research',
        icon: 'sparkles',
        access: 'open',
      },
      {
        id: 'laravel-notion',
        name: 'Launch Plan (Notion)',
        description: 'Milestones, owners and go-to-market checklist.',
        url: 'https://notion.so',
        category: 'Enablement',
        icon: 'book',
        access: 'sso',
      },
      {
        id: 'laravel-authoring',
        name: 'Exam Authoring Tool',
        description: 'Question bank, reviewer comments and blueprint coverage.',
        url: 'https://certificates.dev',
        category: 'Research',
        icon: 'search',
        access: 'shared',
        credentialHint: 'authoring@certificates.dev · in 1Password › Laravel',
      },
      {
        id: 'laravel-crm',
        name: 'HubSpot — Launch Partners',
        description: 'Agency and sponsor conversations for launch support.',
        url: 'https://app.hubspot.com',
        category: 'CRM',
        icon: 'database',
        access: 'sso',
      },
      {
        id: 'laravel-waitlist',
        name: 'Waitlist & Email Campaigns',
        description: 'Pre-launch signups and early-bird announcement sends.',
        url: 'https://mailchimp.com',
        category: 'Comms',
        icon: 'send',
        access: 'shared',
        credentialHint: 'marketing@certificates.dev · in 1Password › Laravel',
      },
    ],
    documents: [
      {
        id: 'laravel-doc-1',
        name: 'Laravel Certification Exam Blueprint',
        kind: 'doc',
        url: 'https://example.com/docs/laravel-blueprint',
        owner: 'Curriculum',
        updated: 'Yesterday',
      },
      {
        id: 'laravel-doc-2',
        name: 'Launch Pricing & Early-Bird Tiers',
        kind: 'sheet',
        url: 'https://example.com/docs/laravel-pricing',
        owner: 'Revenue',
        updated: '2 days ago',
      },
      {
        id: 'laravel-doc-3',
        name: 'Launch Partner Pitch Deck',
        kind: 'deck',
        url: 'https://example.com/docs/laravel-partner-deck',
        owner: 'Sales',
        updated: '5 days ago',
      },
    ],
  },
  {
    id: 'nexioapp',
    password: 'nexio-2026',
    brand: brands.nexioapp,
    name: 'NexioApp',
    client: 'Product — SaaS',
    summary:
      'Product-led SaaS motion. Sales assists on high-intent trials and handles annual plan upgrades.',
    stage: 'Pilot',
    owner: 'Jasper',
    updated: '3 days ago',
    tools: [
      {
        id: 'nexio-claude',
        name: 'Claude.ai',
        description: 'Drafting, research summaries and outreach copy.',
        url: 'https://claude.ai/login',
        category: 'Research',
        icon: 'sparkles',
        access: 'open',
      },
      {
        id: 'nexio-admin',
        name: 'NexioApp Admin Console',
        description: 'Workspaces, plan changes and account impersonation.',
        url: 'https://nexioapp.com',
        category: 'Enablement',
        icon: 'shield',
        access: 'shared',
        credentialHint: 'ops@nexioapp.com · in 1Password › NexioApp',
      },
      {
        id: 'nexio-crm',
        name: 'HubSpot — NexioApp Pipeline',
        description: 'Trial signups, assist queue and upgrade opportunities.',
        url: 'https://app.hubspot.com',
        category: 'CRM',
        icon: 'database',
        access: 'sso',
      },
      {
        id: 'nexio-analytics',
        name: 'Product Analytics',
        description: 'Activation, feature adoption and trial-to-paid funnels.',
        url: 'https://posthog.com',
        category: 'Analytics',
        icon: 'chart',
        access: 'sso',
      },
      {
        id: 'nexio-billing',
        name: 'Stripe — NexioApp',
        description: 'Subscriptions, dunning and annual invoice requests.',
        url: 'https://dashboard.stripe.com',
        category: 'Billing',
        icon: 'card',
        access: 'request',
      },
    ],
    documents: [
      {
        id: 'nexio-doc-1',
        name: 'NexioApp Plan & Feature Matrix',
        kind: 'sheet',
        url: 'https://example.com/docs/nexio-plans',
        owner: 'Product',
        updated: '3 days ago',
      },
      {
        id: 'nexio-doc-2',
        name: 'Sales Assist Rules of Engagement',
        kind: 'doc',
        url: 'https://example.com/docs/nexio-roe',
        owner: 'Revenue Ops',
        updated: '1 week ago',
      },
      {
        id: 'nexio-doc-3',
        name: 'NexioApp Demo Script',
        kind: 'doc',
        url: 'https://example.com/docs/nexio-demo',
        owner: 'Enablement',
        updated: '2 weeks ago',
      },
    ],
  },
  {
    id: 'futura-summit',
    password: 'futura-2026',
    brand: brands['futura-summit'],
    name: 'Futura Summit',
    client: 'Conference — sponsorships & tickets',
    summary:
      'Sponsorship sales and ticket revenue for the summit. Gold and platinum tiers are the priority.',
    stage: 'Selling',
    owner: 'Jasper',
    updated: '8 hours ago',
    tools: [
      {
        id: 'futura-claude',
        name: 'Claude.ai',
        description: 'Drafting, research summaries and outreach copy.',
        url: 'https://claude.ai/login',
        category: 'Research',
        icon: 'sparkles',
        access: 'open',
      },
      {
        id: 'futura-apollo',
        name: 'Apollo.io',
        description: 'Prospecting, contact data and outreach sequences.',
        url: 'https://app.apollo.io/',
        category: 'Research',
        icon: 'search',
        access: 'open',
        screenshot: {
          label: 'Apollo.io login details',
          url: 'https://cdn.magicpatterns.com/uploads/nLUjUZ8xfp8gtXHtmMg6H4/Schermafbeelding_2026-08-01_165855.png',
          alt: 'Apollo.io sign-in form showing the shared email address and password',
          note: 'Internal only — do not share outside the team',
        },
      },
      {
        id: 'futura-attio',
        name: 'Attio CRM',
        description: 'Sponsor pipeline, contacts and deal stages.',
        url: 'https://app.attio.com/conference-sales/',
        category: 'CRM',
        icon: 'database',
        access: 'personal',
        credentialHint: 'Sign in with your own email address',
      },
    ],
    documents: [
      {
        id: 'futura-doc-motion',
        name: 'Sales motion',
        kind: 'doc',
        url: 'https://docs.google.com/document/d/1OSCEpche_zfpqlUmtYtZgVp4ZxMTkwfTjZlDdo7b0EE/edit?usp=sharing',
        owner: 'Google Docs',
        updated: 'Shared with team',
      },
      {
        id: 'futura-doc-1',
        name: 'Sales folder',
        kind: 'folder',
        url: 'https://drive.google.com/drive/folders/1r_tr8dgZFH75gkXQMEKwduWLmT-KiJKI?usp=drive_link',
        owner: 'Google Drive',
        updated: 'Shared with team',
      },
      {
        id: 'futura-doc-2',
        name: 'Partnership Presentation',
        kind: 'deck',
        url: 'https://drive.google.com/file/d/1AKXj08ytQxTyVq5jAecUJWItI4S9GCgQ/view?usp=drive_link',
        owner: 'Google Drive',
        updated: 'Shared with team',
      },
      {
        id: 'futura-doc-3',
        name: 'Briefing',
        kind: 'doc',
        url: 'https://docs.google.com/document/d/1UrU8If0vrSeYosbVtBYVtvek-QIUZgQxZ_PIrjk612c/edit?usp=sharing',
        owner: 'Google Docs',
        updated: 'Shared with team',
      },
      {
        id: 'futura-doc-4',
        name: 'LinkedIn texts',
        kind: 'doc',
        url: 'https://docs.google.com/document/d/1BJo5T0jQIE4HbvyYy0bAvEu-Wv6cMKvVfXSknYDT_Rs/edit?usp=sharing',
        owner: 'Google Docs',
        updated: 'Shared with team',
      },
    ],
  },
  {
    id: 'swedish-wealth-foundation',
    password: 'swf-2026',
    brand: brands['swedish-wealth-foundation'],
    name: 'Swedish Wealth Foundation',
    client: 'Investment & advisory',
    summary:
      'Investor relations and advisory mandates. Materials here are confidential — share externally only on request.',
    stage: 'Active',
    owner: 'Jasper',
    updated: '2 days ago',
    tools: [
      {
        id: 'swf-claude',
        name: 'Claude.ai',
        description: 'Drafting, research summaries and outreach copy.',
        url: 'https://claude.ai/login',
        category: 'Research',
        icon: 'sparkles',
        access: 'open',
      },
      {
        id: 'swf-crm',
        name: 'Investor CRM',
        description: 'Investor contacts, commitments and follow-up cadence.',
        url: 'https://app.hubspot.com',
        category: 'CRM',
        icon: 'database',
        access: 'sso',
      },
      {
        id: 'swf-portfolio',
        name: 'Portfolio Reporting',
        description: 'Holdings, performance and allocation reporting.',
        url: 'https://metabase.com',
        category: 'Analytics',
        icon: 'chart',
        access: 'request',
      },
      {
        id: 'swf-dataroom',
        name: 'Secure Data Room',
        description: 'Due-diligence materials for prospective investors.',
        url: 'https://example.com/dataroom/swf',
        category: 'Research',
        icon: 'shield',
        access: 'request',
      },
      {
        id: 'swf-drive',
        name: 'Shared Drive — SWF',
        description: 'Board materials, memos and signed documents.',
        url: 'https://drive.google.com',
        category: 'Enablement',
        icon: 'link',
        access: 'sso',
      },
    ],
    documents: [
      {
        id: 'swf-doc-motion',
        name: 'Sales motion',
        kind: 'doc',
        url: 'https://docs.google.com/document/d/1OSCEpche_zfpqlUmtYtZgVp4ZxMTkwfTjZlDdo7b0EE/edit?usp=sharing',
        owner: 'Google Docs',
        updated: 'Shared with team',
      },
      {
        id: 'swf-doc-1',
        name: 'Investor Overview Deck',
        kind: 'deck',
        url: 'https://example.com/docs/swf-overview',
        owner: 'Investor Relations',
        updated: '2 days ago',
      },
      {
        id: 'swf-doc-2',
        name: 'Quarterly Performance Report',
        kind: 'pdf',
        url: 'https://example.com/docs/swf-quarterly',
        owner: 'Finance',
        updated: '1 week ago',
      },
      {
        id: 'swf-doc-3',
        name: 'Mandate Terms Summary',
        kind: 'doc',
        url: 'https://example.com/docs/swf-mandate',
        owner: 'Legal',
        updated: '3 weeks ago',
      },
    ],
  },
]
